export const SCHEDULE_DOCUMENTS_TITLE = "Schedule documents";
export const SCHEDULE_DOCUMENTS_GENERATE_TITLE = "1. Generate schedule";
export const SCHEDULE_DOCUMENTS_ATTACH_TITLE = "2. Attach to INSIGHT";

export const SCHEDULE_DOCUMENTS_INTRO =
  "Requires stamped commercial terms under the Fuse policy number (FUSE-…). " +
  "Step 1 generates the Word schedule from that Neon bound snapshot (no INSIGHT draft needed). " +
  "Step 2 attach needs an INSIGHT draft from the Post to INSIGHT rail first.";

export const SCHEDULE_DOCUMENTS_MISSING_IDENTITY =
  "Connect the client, producing broker and policy to INSIGHT before attaching a document.";

export const SCHEDULE_DOCUMENTS_MISSING_FUSE =
  "Generate needs the Fuse policy number (FUSE-…). Stamp commercial terms first — do not use the Zoho workflow name (POL-*).";

export const SCHEDULE_DOCUMENTS_ALREADY_GENERATED =
  "A schedule has already been generated for this billing line.";

export const SCHEDULE_DOCUMENTS_REGENERATE_HELP =
  "Regenerating replaces the sticky generated-document record and clears its previous attachment marker. Continue?";

export const SCHEDULE_DOCUMENTS_ATTACH_MISMATCH =
  "The two INSIGHT transaction IDs must match exactly.";

export const SCHEDULE_DOCUMENTS_ATTACH_SUCCESS =
  "The schedule was attached only. This did not invoice or post the transaction.";

export default {
  SCHEDULE_DOCUMENTS_TITLE,
  SCHEDULE_DOCUMENTS_GENERATE_TITLE,
  SCHEDULE_DOCUMENTS_ATTACH_TITLE,
  SCHEDULE_DOCUMENTS_INTRO,
  SCHEDULE_DOCUMENTS_MISSING_IDENTITY,
  SCHEDULE_DOCUMENTS_MISSING_FUSE,
  SCHEDULE_DOCUMENTS_ALREADY_GENERATED,
  SCHEDULE_DOCUMENTS_REGENERATE_HELP,
  SCHEDULE_DOCUMENTS_ATTACH_MISMATCH,
  SCHEDULE_DOCUMENTS_ATTACH_SUCCESS
};
